import { Device, from, between } from '@helpers/media';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Title = styled.h2 `
  ${HeadingStyles.H4Styles}

  ${({ contentStyle }) => css `
      text-align: ${contentStyle};
    `}

  @media ${between(Device.Tablet, Device.TabletLarge)} {
    grid-template-columns: repeat(2, 1fr);

    ${({ itemCount }) => itemCount < 2 &&
    css `
        text-align: center;
      `}
  }

  @media ${between(Device.TabletLarge, Device.Desktop)} {
    ${({ itemCount }) => itemCount < 3 &&
    css `
        text-align: center;
      `}
  }

  @media ${from(Device.Desktop)} {
    margin: 0 0 48px;

    ${({ itemCount }) => itemCount < 4 &&
    css `
        text-align: center;
      `}
  }
`;
const Item = styled.div ``;
const ItemList = styled.div `
  display: grid;
  gap: 24px 10px;
  grid-template-columns: 1fr;

  @media ${between(Device.Tablet, Device.TabletLarge)} {
    grid-template-columns: repeat(2, 1fr);

    ${({ itemCount, contentStyle }) => itemCount < 2 &&
    css `
        display: flex;
        justify-content: ${contentStyle};
        ${Item} {
          width: 50%;
        }
      `}
  }

  @media ${between(Device.TabletLarge, Device.Desktop)} {
    row-gap: 30px;
    grid-template-columns: repeat(3, 1fr);

    ${({ itemCount, contentStyle }) => itemCount < 3 &&
    css `
        display: flex;
        justify-content: ${contentStyle};
        ${Item} {
          width: 33%;
        }
      `}
  }

  @media ${from(Device.Desktop)} {
    row-gap: 30px;
    grid-template-columns: repeat(4, 1fr);

    ${({ itemCount, contentStyle }) => itemCount < 4 &&
    css `
        display: flex;
        justify-content: ${contentStyle};
        ${Item} {
          width: 25%;
        }
      `}
  }
`;
export default {
    Container,
    Item,
    ItemList,
    Title,
};
